import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { skipLoader } from 'app/core/interceptors/loader.interceptor';
import { Observable } from 'rxjs';

// ! WTF is this shit? Wrapper for a wrapper?
@Injectable({
  providedIn: 'root'
})
export class DataService {
  #http = inject(HttpClient);

  public get<T>(controller: string, headers?: any): Observable<T> {
    return this.#http.get<T>(controller,{headers:headers});
  }

  public post<T>(controller: string, body: any, headers?: any, skipLoader?: boolean): Observable<T> {
    let url = controller;
    if (skipLoader) {
      url += `${(url.includes('?') ? '&' : '?')}skipLoader=${skipLoader}`;
    }
    return this.#http.post<T>(url, body, { headers: headers });
  }

}
